import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContactListComponent } from './contact-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { ContactService } from './contact.service';
import { ContactModel } from './contact.model';

@Component({
    selector: 'convfact-contactdelete',
    templateUrl: './contact-dialog-delete.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})

export class ContactDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    message_response: string;
    error = false;
    contact: ContactModel;

    constructor(
        public dialogRef: MatDialogRef<ContactListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public contactService: ContactService
    ) { }

    delete() {
        this.contactService.deleteData(this.uid)
        .then(response => this.message_response = response)
        .catch(error => this.message_response = error.error.message);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
